export default "../css/3f53cb2398a2ce55a4a440fd32198832.ttf";